// components/Footer.js
import React from 'react';
import PinDropIcon from '@mui/icons-material/PinDrop';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div style={{fontSize:25, fontWeight: 200, marginTop: 60}}><b>MATHS GEM SEYCHELLES</b></div>
        <div style={{textAlign: 'center', padding: 20}} className="contact">
          <h3>Quick Links</h3>
          <br/>
          <a style={{textDecoration: 'none', color: 'white'}} href="/">Home</a>
          <br/>
          <a style={{textDecoration: 'none', color: 'white'}} href="/">Contact Us</a>
          <br/>
          <a style={{textDecoration: 'none', color: 'white'}} href="/">Sign Up</a>
        </div>
        <div style={{textAlign: 'center', padding: 20}} className="contact">
          <h3 style={{textAlign: 'center'}}>Contact Us</h3>
          <br/>
          <p>Anse a la Mouche, Baie Lazare,<br/> Mahe, Seychelles</p>
          <p>Contact Us: mathsgemseychelles@gmail.com</p>
          <p>Phone: +248 2825054</p>
        </div>
      </div>
      <h4>© Copyright {new Date().getFullYear().toString()}</h4>
    </footer>
  );
};

export default Footer;